import { render, staticRenderFns } from "./PerfilUsuario.vue?vue&type=template&id=759bad1b"
import script from "./PerfilUsuario.vue?vue&type=script&lang=js"
export * from "./PerfilUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports